import React from 'react';
import JobTable from '../components/JobTable';
import HomeVideoPlayer from '../components/HomeVideoPlayer';
import SEO from '../components/SEO';
import { categories, qualifications } from '../data/jobs';
import './HomePage.css';

const ENABLE_HOME_VIDEO_PLAYER = false  ;

const HomePage = () => {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Sarkari Naukri Rajasthan',
    url: 'https://sarkarinaukrirajasthan.com/',
    description: 'Latest Rajasthan Government Jobs, Sarkari Naukri, Results and Admit Cards',
    publisher: {
      '@type': 'Organization',
      name: 'Sarkari Naukri Rajasthan',
      url: 'https://sarkarinaukrirajasthan.com/',
    },
  };

  return (
    <div className="home-page">
      <SEO
        title="Latest Government Jobs, Results & Admit Cards 2026"
        description="Sarkari Naukri Rajasthan - Find latest Rajasthan government jobs 2026. Central Govt, State Govt, Bank, Railway, Defence and PSU vacancies. Apply online for 10th pass, 12th pass, graduate jobs."
        path="/"
        structuredData={orgSchema}
      />
      <div className="home-hero">
        <h1 className="home-hero-title">Sarkari Naukri Rajasthan 2026</h1>
        <p className="home-hero-sub">
          Latest Rajasthan Government Jobs - Central Govt, State Govt, Bank, Railway,
          Defence and PSU vacancies. Find sarkari naukri for 10th pass, 12th pass,
          graduate and post-graduate qualifications. Apply online today!
        </p>
      </div>

      {ENABLE_HOME_VIDEO_PLAYER ? <HomeVideoPlayer /> : null}

      <div className="home-tables-grid">
        <JobTable
          title="Jobs by Category"
          icon="Jobs"
          items={categories}
          columnHeader="Category Name"
          getCategoryHref={(id) => `/category/${id}`}
        />
        <JobTable
          title="Jobs by Qualification"
          icon="Qual"
          items={qualifications}
          columnHeader="Qualification"
          getCategoryHref={(id) => `/category/${id}`}
        />
      </div>
    </div>
  );
};

export default HomePage;
